import { format, formatDuration, intervalToDuration } from 'date-fns'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'
import { Category } from './category'

export class NoticeEngineer extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new NoticeEngineer(), {
      category: new SerialisationConfig(() => new Category()),
    })

  @alias('id')
  id!: number
  @alias('first_name')
  firstName!: string
  @alias('last_name')
  lastName!: string
  @alias('email')
  email!: string
  @alias('category')
  category!: Category
  @alias('sent_at')
  sent!: Date
  @alias('first_access_started_at')
  firstAccessStarted!: Date
  @alias('first_access_ended_at')
  firstAccessEnded!: Date
  @alias('last_access_started_at')
  lastAccessStarted!: Date
  @alias('last_access_ended_at')
  lastAccessEnded!: Date

  get name(): string {
    if (this.firstName != null && this.lastName != null) {
      return `${this.firstName} ${this.lastName}`
    } else if (this.firstName != null) {
      return this.firstName
    } else if (this.lastName != null) {
      return this.lastName
    } else {
      return 'Engineer'
    }
  }

  get firstAccess(): string | null {
    if (this.firstAccessStarted && this.firstAccessEnded) {
      return [
        format(this.firstAccessStarted, 'dd/MM/yyyy - HH:mm'),
        `(${formatDuration(intervalToDuration({ start: this.firstAccessEnded, end: this.firstAccessStarted }))})`,
      ].join(' ')
    }
    return null
  }

  get lastAccess(): string | null {
    if (this.lastAccessStarted && this.lastAccessEnded) {
      return [
        format(this.lastAccessStarted, 'dd/MM/yyyy - HH:mm'),
        `(${formatDuration(intervalToDuration({ start: this.lastAccessEnded, end: this.lastAccessStarted }))})`,
      ].join(' ')
    }
    return null
  }

  constructor() {
    super((NoticeEngineer as unknown as AliasedConstructor)._alias)
  }
}
